export default __webpack_public_path__ + "static/media/color_awards_winner.85087cef.jpeg";